import { LookupKeys } from '../../../models/crm/lookup.model';
import { LookupBase } from '../../../models/utils/lookup-base.model';

export interface ProductsTableColumnDefinition {
  dataField: ProductsTableKeys;
  caption: string;
  dataType: 'string' | 'number' | 'date' | 'datetime' | 'boolean';
  required?: boolean;
}

export enum ProductTypeEnum {
  NotSet = 'NOT SET',
  Claim = 'CLAIM',
  Ful = 'FUL',
  Iul = 'IUL',
  Myga = 'MYGA',
  Spda = 'SPDA',
  Term = 'TERM',
  Ul = 'UL',
  WholeLife = 'WHOLE LIFE',
}

export const PRODUCT_TYPE_NOT_SET = ProductTypeEnum.NotSet;

export const PRODUCT_TYPE_VALUES = [
  ProductTypeEnum.NotSet,
  ProductTypeEnum.Claim,
  ProductTypeEnum.Ful,
  ProductTypeEnum.Iul,
  ProductTypeEnum.Myga,
  ProductTypeEnum.Spda,
  ProductTypeEnum.Term,
  ProductTypeEnum.Ul,
  ProductTypeEnum.WholeLife,
] as const;

export type ProductType = (typeof PRODUCT_TYPE_VALUES)[number];

export const PRODUCT_TYPE_LOOKUP: LookupBase[] = PRODUCT_TYPE_VALUES.map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: value };
});

export enum ProductsTableKeys {
  id = 'id',
  productType = 'product_type',
  isNyProduct = 'is_ny_product',
  productName = 'product_name',
  carrier = 'carrier',
  isActive = 'is_active',
  requiredUserInput = 'required_user_input',
  comment = 'comment',
}

export interface ProductRecord {
  [ProductsTableKeys.id]?: number;
  [ProductsTableKeys.productType]: ProductType;
  [ProductsTableKeys.isNyProduct]: boolean;
  [ProductsTableKeys.productName]: string;
  [ProductsTableKeys.carrier]: string;
  [ProductsTableKeys.isActive]: boolean;
  [ProductsTableKeys.requiredUserInput]: boolean;
  [ProductsTableKeys.comment]?: string | null;
}
